import useReduxState from '@hooks/useReduxState';
import { TTtransactionModalTabs } from '@components/layout';
import Modal from '@components/modal';
import Tabs, { ITabItem } from '@components/tabs';

import { BREAKPOINTS } from '@consts/ui';
import Deposit from './DepositTab';
import Withdraw from './WithdrawTab';
import Coupon from './CouponTab';

import styles from './DepositWithdrawModal.module.scss';

interface IDepositAndWithdrawalProps {
  isOpen: boolean;
  close: () => void;
  selectedTabToOpen: TTtransactionModalTabs;
}

const DepositAndWithdrawal = ({ close, isOpen, selectedTabToOpen }: IDepositAndWithdrawalProps): JSX.Element => {
  const [{ windowWidth }] = useReduxState((state) => state.ui);

  /* Components */

  const desktopTabs: ITabItem[] = [
    { tab: { content: 'Deposit' }, paneContent: <Deposit /> },
    { tab: { content: 'Withdraw' }, paneContent: <Withdraw /> },
    { tab: { content: 'Coupon' }, paneContent: <Coupon /> },
  ];

  const mobileTabs: ITabItem[] = [
    { tab: { content: 'Deposit' }, paneContent: <Deposit /> },
    { tab: { content: 'Withdraw' }, paneContent: <Withdraw /> },
    { tab: { content: 'Coupon' }, paneContent: <Coupon /> },
  ];

  return (
    <Modal {...{ close, isOpen }} className={styles.depositAndWithdrawal}>
      <Tabs tabs={windowWidth < BREAKPOINTS.LG ? mobileTabs : desktopTabs} color='dark' tabOpenedByDefault={selectedTabToOpen} />
    </Modal>
  );
};
export default DepositAndWithdrawal;
